import {MutationTree} from "vuex";
import {OnlineUsersState} from "../types/OnlineUsersState";
import {OnlineCounterData} from "../../types/OnlineCounterData";
import Vue from 'vue';
import {OnlineActivityParam} from "@service/store/types/OnlineActivityParam";
import {OnlineActivitiesCounter, OnlineActivityCountersList} from "@service/store/types/OnlineActivitiesCounter";

export const mutations: MutationTree<OnlineUsersState> = {
    setCounters(state, counters) {
        for (const [key, value] of Object.entries(counters)) {
            Vue.set(state.counters, key, value as OnlineCounterData);
        }
    },
    clearWatches(state) {
        for (const [key, value] of Object.entries(state.counters)) {
            if (state.watches[key]) {
                Vue.delete(state.counters, key);
            }
        }
        state.watches = {};
    },
    setActivities(state, newData: OnlineActivityCountersList) {
        state.activities = newData;
    },
    setWatches(state, newData: OnlineActivityCountersList) {
        state.watches = newData;
    },
    setNeedCounters(state, value: boolean) {
        state.needCounters = value;
    }
}